import { makeStyles } from "@mui/styles";
import { Theme } from "@mui/material/styles/createTheme";

export const useStyles = makeStyles((theme: Theme) => ({
    detailsWrapper: {
        padding: "0px 22px 22px 22px",
    },
    mainWrapper: {
        backgroundColor: theme.palette.primary.main,
        boxShadow: "0px 2px 9px rgba(19, 61, 133, 0.15)",
        width: "100%",
        padding: "32px",
        borderRadius: "4px",
        marginTop: "16px",
    },
    mainWrapperLoading: {
        display: "flex",
        width: "100%",
        justifyContent: "center",
        alignItems: "center",
    },
    mainWrapperHeader: {
        display: "flex",
        justifyContent: "space-between",
        alignItems: "center",
        marginBottom: "12px",
    },
    mainWrapperHeaderTitle: {
        color: theme.palette.info.main,
        fontSize: "18px",
        fontWeight: 400,
    },
    informationWrapper: {
        display: "flex",
    },
    informationLeft: {
        display: "grid",
        gridTemplateColumns: "repeat(3, 1fr)",
        gap: "24px",
        paddingRight: "32px",
    },
    informationRight: {
        paddingLeft: "32px",
        borderLeft: `1px solid ${theme.palette.border.verticalDivider}`,
    },
    informationItem: {
        display: "flex",
        flexDirection: "column",
        gap: "8px",
        flexGrow: 1,
    },
    label: {
        fontFamily: "Source Sans 3",
        fontWeight: 700,
        fontSize: "12px",
        textTransform: "uppercase",
        color: theme.palette.primary.dark,
    },
    value: {
        fontSize: 14,
    },
    userWrapper: {
        marginBottom: "24px",
    },
    userTitle: {
        fontSize: "14px",
    },
    userEmail: {
        fontSize: "14px",
        color: theme.palette.info.main,
    },
    labelWithSpace: {
        marginBottom: "8px",
    },
    sectionWrapper: {
        marginTop: "68px",
    },
    shiftsTableWrapper: {
        marginTop: "24px",
    },
    shiftWrapper: {
        marginBottom: "24px",
    },
    shiftTitle: {
        fontSize: "14px",
        fontWeight: 400,
        padding: 16,
        backgroundColor: theme.palette.graphs.main,
    },
    shiftTable: {
        display: "grid",
        gridTemplateColumns: "repeat(7, 1fr)",
    },
    shiftTableItem: {
        marginTop: "18px",
    },
    shiftTime: {
        marginTop: "14px",
        padding: "8px",
        borderLeft: `1px solid ${theme.palette.border.verticalDivider}`,
        " &:last-child": {
            borderRight: `1px solid ${theme.palette.border.verticalDivider}`,
        },
    },
    shiftTableLabel: {
        marginLeft: "9px",
    },
    shiftTableNoShift: {
        width: "100%",
        display: "flex",
        justifyContent: "center",
        alignItems: "center",
        paddingTop: 24,
    },
    shiftTableNoShiftText: {
        fontSize: "14px",
        fontStyle: "italic",
    },
    settingsWrapper: {
        width: "100%",
        display: "flex",
        marginTop: "24px",
    },
}));
